import React from "react";
import Icon from "../../icon";
import IconButton from "@mui/material/IconButton";
import { Fab, TextField, Typography } from "@mui/material";

export interface RowData {
    id: number;
    mmbarang_id: number;
    nama_barang: string;
    qty: number;
    stok?: number;
}

interface TableRowsProps {
    rowsData: RowData[];
    deleteTableRows: (index: number) => void;
    // terima event dari TextField (input or textarea) atau native input
    handleTable: (
        index: number,
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => void;
}

const TableRowsPenggunaanBarang: React.FC<TableRowsProps> = ({
    rowsData,
    deleteTableRows,
    handleTable,
}) => {
    return (
        <>
            {rowsData.map((data, index) => {
                const { id, mmbarang_id, nama_barang, qty } = data;

                return (
                    <tr key={id ?? index}>
                        <td hidden>
                            {/* native input -> cast ke ChangeEvent<HTMLInputElement> jika TypeScript ngambek */}
                            <input
                                type="number"
                                name="id"
                                value={id}
                                onChange={(ev) =>
                                    handleTable(index, ev as React.ChangeEvent<HTMLInputElement>)
                                }
                            />
                        </td>

                        <td hidden>
                            <input
                                type="number"
                                name="mmbarang_id"
                                value={mmbarang_id}
                                onChange={(ev) =>
                                    handleTable(index, ev as React.ChangeEvent<HTMLInputElement>)
                                }
                            />
                        </td>

                        <td width={450} style={{ paddingBottom: 8 }}>
                            <Typography variant="body1">{nama_barang}</Typography>
                        </td>

                        <td width={150} style={{ paddingBottom: 8 }}>
                            <TextField
                                label="Quantity"
                                name="qty"
                                type="number"
                                value={qty}
                                // TextField mengirim ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
                                onChange={(ev) => handleTable(index, ev)}
                                fullWidth
                            />
                        </td>

                        <td width={5} style={{ paddingBottom: 8 }}>
                            <Fab
                                color="error"
                                sx={{ mr: 0.5, ml: 5 }}
                                size="small"
                                onClick={() => deleteTableRows(index)}
                            >
                                <IconButton sx={{ color: "text.primary" }}>
                                    <Icon icon="mdi:trash" fontSize={24} color="white" />
                                </IconButton>
                            </Fab>
                        </td>
                    </tr>
                );
            })}
        </>
    );
};

export default TableRowsPenggunaanBarang;
